module.exports = __webpack_public_path__ + "Diamo.jpg?fed11c37c6b8256deefc745c87dffb67";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/Diamo.jpg
// module id = 237
// module chunks = 0